import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export const PainSection = () => {
  const quotes = ['Estoy agotado físicamente pero mi cabeza no para.', 'Quiero dormir pero no puedo apagar los pensamientos.', 'Me duermo y me despierto a las 3 AM con la cabeza encendida.'];
  return <Section darker id="dolor" data-id="element-166">
      <div className="max-w-3xl mx-auto" data-id="element-167">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-white" data-id="element-168">
          ¿Te pasa esto?
        </h2>

        <div className="space-y-6" data-id="element-169">
          {quotes.map((quote, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-night-800 p-6 md:p-8 rounded-2xl border border-night-700 shadow-lg relative overflow-hidden" data-id="element-170">
              <div className="absolute top-0 left-0 w-1 h-full bg-accent-blue" data-id="element-171" />
              <p className="text-xl md:text-2xl text-gray-200 italic font-medium" data-id="element-172">
                "{quote}"
              </p>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-173">
          <p className="text-lg md:text-xl text-gray-300 mb-10 leading-relaxed" data-id="element-174">
            Si te identificaste con alguna de estas frases, seguí leyendo.
            <br data-id="element-175" />
            <span className="text-white font-bold" data-id="element-176">
              Lo que vas a encontrar acá cambió la noche de miles de personas.
            </span>
          </p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-177">
            <Button href="#compra" variant="secondary" className="max-w-md mx-auto" data-id="element-178">
              MOSTRAME LA SOLUCIÓN
            </Button>
          </motion.div>
        </div>
      </div>
    </Section>;
};